// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__2ba2a","hint":"styles_hint__Qwf5x"};